import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TransfersHistoryLoader from '../show/transfersHistory/_load/TransfersHistoryLoader'
import TransfersHistoryTable from '../show/transfersHistory/table/TransfersHistoryTable'
import Scroll from '../../../components/helpers/Scroll'

const TransfersHistoryModal = props => {
  return (
    <ControlledModal width="58rem" {...props}>
      <ModalHeader />
      <Separator weight={4} />
      <Scroll overflowX={'hidden'} overflowY={'auto'} maxHeight="35rem" width="45rem" height="100%">
        <FilterHandler>
          <TransfersHistoryLoader>
            <TransfersHistoryTable />
          </TransfersHistoryLoader>
        </FilterHandler>
      </Scroll>
    </ControlledModal>
  )
}

export default TransfersHistoryModal
